export default __webpack_public_path__ + "static/media/Img0001.e27eaf5b.png";